<template>
  <div class="shortTime">
    <div class="publishTime">{{ time }}</div>
    <div class="publishContent">{{ content }}</div>
  </div>
</template>

<script>
import { home } from '../../api/index'
import '../../assets/js/DateFormat'
export default {
  created () {
    home.getGZ_shortTime().then(data => {
      this.time = new Date(data.pptime).format('yyyy时MM月dd日 hh时mm分')
      this.content = data.forecast
    })
  },
  data () {
    return {
      // 发布时间
      time: '',

      // 发布内容
      content: ''
    }
  }
}
</script>

<style lang="less" scoped>
.shortTime {
  display: flex;
  flex-direction: column;
  .publishTime {
    align-self: flex-end;
  }
}
</style>
